import { getVersion}  from './version';

const baseAPI = 'https://api.rvrolijkcapstone.com';

export default function getAPI(){
    return baseAPI + '/' + getVersion();
}